import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
  NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/notice/product/models';

const NoticeProductList = (props) => {
  const { noticeProductList, getList, getExcelDownload, deleteNoticeProduct } = props;
  const { list, filterOption, sortOption, pagination, summary } = noticeProductList;

  return (
    <div className="notice-store-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
          sortOption: NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText="요청하신 검색 필터로 검색된 상품 공지사항 리스트가 없습니다."
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            deleteNoticeProduct,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default NoticeProductList;
